// extracted by mini-css-extract-plugin
export default {"UnderConstruction":"style_UnderConstruction__Uaycb"};